/** Grid for quotation editor lines: one row per line on desktop, stacked areas on phones. */
const AREAS = {
  xs: `"item item del" "qty unit unit" "price total total" "extra extra extra"`,
  md: `"num item qty unit price total del" ". extra extra extra extra extra ."`,
};

export const LINE_GRID = {
  display: 'grid',
  columnGap: 1.5,
  rowGap: 1.25,
  alignItems: 'start',
  gridTemplateColumns: {
    xs: '1fr 1fr 40px',
    md: '28px minmax(0, 1fr) 96px 112px 132px 136px 40px',
  },
  gridTemplateAreas: { xs: AREAS.xs, md: AREAS.md },
} as const;
